import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactsListComponent } from './contacts-list.component';
import {SharedModule} from "../components/shared.module";
import {ContactsRoutingModule} from "./contacts-routing.module";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {ContactsComponent} from "./contacts.component";
import {MatChipsModule} from "@angular/material/chips";
import {MatPaginatorModule} from "@angular/material/paginator";
import { ContactsFundInvestorsTableComponent } from './contacts-subcomponents/contacts-fund-investors-table/contacts-fund-investors-table.component';
import { ContactDealsTableComponent } from './contacts-subcomponents/contact-deals-table/contact-deals-table.component';
import { ContactsOutletsTableComponent } from './contacts-subcomponents/contacts-outlets-table/contacts-outlets-table.component';
import {MatDividerModule} from "@angular/material/divider";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";



@NgModule({
  declarations: [
    ContactsListComponent,
    ContactsComponent,
    ContactsFundInvestorsTableComponent,
    ContactDealsTableComponent,
    ContactsOutletsTableComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ContactsRoutingModule,
    MatSortModule,
    MatTableModule,
    MatChipsModule,
    MatPaginatorModule,
    MatDividerModule,
    MatProgressSpinnerModule,
  ]
})
export class ContactsModule { }
